import React from "react";
import { LegacyCard as Card, Text, Pagination, Select, InlineStack } from "@shopify/polaris";
import PropTypes from "prop-types";

const SellerListFooter = (props) => {
  const { currentPage, onPerPage, onSelectLimit, optionsList, perPageCount, sellerListCMS, totalCount } = props;

  const { label } = sellerListCMS;
  return (
    <>
      <Card.Section>
        <InlineStack>
          <Text variant="headingMd" as="h2">
            {`${label.total}`}
            <span className="totalCount">{totalCount}</span>
          </Text>
          <Pagination
            hasPrevious={(totalCount && currentPage !== 1 && true) || false}
            onPrevious={() => {
              if (currentPage !== 1) {
                onPerPage(currentPage - 1);
              }
            }}
            hasNext={(currentPage < totalCount && true) || false}
            onNext={() => {
              if (currentPage <= totalCount) {
                onPerPage(currentPage + 1);
              }
            }}
          />
          <Select value={perPageCount} options={optionsList} onChange={onSelectLimit} />
        </InlineStack>
      </Card.Section>
    </>
  );
};

SellerListFooter.defaultProps = {
  optionsList: [],
  perPageCount: "",
  totalCount: "",
  currentPage: 1,
  onSelectLimit: () => {},
  onPerPage: () => {},
};

SellerListFooter.propTypes = {
  optionsList: PropTypes.arrayOf(PropTypes.object),
  perPageCount: PropTypes.number,
  totalCount: PropTypes.number,
  onSelectLimit: PropTypes.func,
  onPerPage: PropTypes.func,
  currentPage: PropTypes.number,
  sellerListCMS: PropTypes.func.isRequired,
};

export default SellerListFooter;
